export default __webpack_public_path__ + "alberta-fab-status.3ca36d4c75d860d05f5b.svg";